import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import TextToSpeech from "./pages/TextToSpeech";
import ChatInterface from "./pages/LargeLangModel";
import SpeechToText from "./pages/SpeechToText";
import NamedEntityRecognition from "./pages/NamedEntityRecognition";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext";
import ImageCaptioning from "./pages/ImageCaptioning";
import OCR from "./pages/OpticalImgRec";
import Pipelines from "./pages/Pipelines";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import Footer from "./components/LanguageSwitcher";
import Layout from "./components/Layout";
import KazClip from "./pages/KazClip";
import TextSummarization from "./pages/TextSummarization";
import QuestionAnswering from "./pages/QA";
import MachineTranslation from "./pages/MT";
import VideoClip from "./pages/VideoClip";
import { jwtDecode } from "jwt-decode";
import DocumentQA from "./pages/OCRdocument";

interface JwtPayload {
  exp: number;
}

function isTokenExpired(token: string): boolean {
  try {
    // Remove "Bearer " if it exists
    const rawToken = token.startsWith("Bearer ") ? token.slice(7) : token;

    const decoded = jwtDecode<JwtPayload>(rawToken);
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  } catch (error) {
    // If decoding fails, consider the token invalid
    return true;
  }
}

const token = localStorage.getItem("token");

if (token && isTokenExpired(token)) {
  localStorage.removeItem("token");
  // optionally redirect to login or refresh
}

function App() {
  const token = localStorage.getItem("token");
  // console.log("App rendered, token:", token);
  return (
    <I18nextProvider i18n={i18n}>
      {/* <LanguageSwitcher /> */}
      <AuthProvider>
        <UserProvider>
          <Router>
            <div className="App">
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/pipelines" element={<Pipelines />} />

                  <Route element={<ProtectedRoute />}>
                    <Route path="/text-to-speech" element={<TextToSpeech />} />
                    <Route path="/llm" element={<ChatInterface />} />
                    <Route path="/text-to-speech" element={<TextToSpeech />} />
                    <Route path="/speech-to-text" element={<SpeechToText />} />
                    <Route
                      path="/named-entity-recognition"
                      element={<NamedEntityRecognition />}
                    />
                    <Route
                      path="/imgcaptioning"
                      element={<ImageCaptioning />}
                    />
                    <Route path="/ocr" element={<OCR />} />
                    <Route
                      path="/text-summarization"
                      element={<TextSummarization />}
                    />
                    <Route path="/qa" element={<QuestionAnswering />} />
                    <Route
                      path="/machine-translation"
                      element={<MachineTranslation />}
                    />
                    <Route path="/video-clip" element={<VideoClip />} />
                    <Route path="/kazclip" element={<KazClip />} />
                    <Route
                      path="/ocr-document-search"
                      element={<DocumentQA />}
                    />
                  </Route>
                </Routes>{" "}
              </Layout>
            </div>
          </Router>
        </UserProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
